import { render, staticRenderFns } from "./weeklyStatistics.vue?vue&type=template&id=64ab6044&scoped=true&"
import script from "./weeklyStatistics.vue?vue&type=script&lang=js&"
export * from "./weeklyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./weeklyStatistics.vue?vue&type=style&index=0&id=64ab6044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab6044",
  null
  
)

export default component.exports